import { Money } from '../utils/currency';

export enum VatTypes {
  ZERO = 0,
  SIX = 6,
  TWELVE = 12,
  TWENTYFIVE = 25,
}

export enum PriceType {
  STATIC = 'fast',
  DYNAMIC = 'rörligt',
}

export enum ProductType {
  PRODUCT = 'PRODUCT',
  SERVICE = 'SERVICE',
}
export interface Product {
  id: string;
  image?: string;
  price: Money;
  priceType: string;
  tax: VatTypes;
  title: string;
  type: string;
  unitType: string;
  removed?: boolean;
  tags?: string[];
  source?: string;
  showDecimals?: boolean;
  showInShop?: boolean;
  articleNumber?: string;
  ean?: {
    code: string;
    type: string;
    decimals: string;
  };
  category?: string;
}

export interface ProductDTO {
  image: string;
  showInShop?: boolean;
  title: string;
  category?: string;
  priceType: string;
  price: number;
  tax: VatTypes;
  unitType: string;
  type: ProductType;
  showDecimals?: boolean;
  ean?: string;
}
